import styled, { css } from "styled-components";
import { Link } from "react-router";

interface LinkStyleProps {
  color?: string;
  display?: string;
  textDecoration?: string;
}

const sharedStyle = css<LinkStyleProps>`
  display: ${(props) => (props.display === "block" ? "block" : "inline-block")};
  color: ${(props) => props.color || props.theme.linkColor};
  text-decoration: ${(props) => props.textDecoration || "none"};
  &:hover,
  &:focus,
  &:active {
    color: ${(props) => props.color || props.theme.linkColor};
    text-decoration: underline;
  }
`;

const LinkStyled = styled(Link)<LinkStyleProps>`
  ${sharedStyle}
`;

const LinkHrefStyled = styled.a<LinkStyleProps>`
  ${sharedStyle}
`;

export { LinkStyled, LinkHrefStyled };
